import { COMMISSIONED_OPINIONS, TOTAL_PUBLISHED } from '../actions';

export default ( state = {
	totalPublished: 0, commissioned: ''
}, action ) => {
	switch ( action.type ) {
		case TOTAL_PUBLISHED:
			return {
				totalPublished: action.payload,
				commissioned: state.commissioned
			};
		case COMMISSIONED_OPINIONS:
			return {
				totalPublished: state.totalPublished,
				commissioned  : action.payload
			};
	}

	return state;
}